<div class="dialog-header">
  <app-bar
    [title]="modalTitle || 'Identificação'"
    [backButtonProps]="{ icon: 'caret-down', variant: 'regular', color: 'neutral', size: 'medium' }"
    (backButtonClick)="handleBackToHome()"
  ></app-bar>
</div>
<div class="dialog-container">
  @if(step === 'phone') {
    <div class="dialog-body">
      <div class="d-column gap-1">
        <label class="label-medium-medium">
          Qual o seu celular? *
        </label>

        <app-flag-phone-input
          class="w-100"
          [phone]="phone"
          [error]="phoneInlineErrorMessage !== null && !phoneDataIsValid"
          (dataEmitter)="handlePhoneData($event)"
        ></app-flag-phone-input>

        @if(phoneInlineErrorMessage !== null && !phoneDataIsValid) {
          <p class="label-regular-small text-color-critical d-flex align-items-center gap-1">
            <mnt-icon icon="signalingWarningCircle" color="currentColor" size="small"></mnt-icon>
            {{ phoneInlineErrorMessage }}
          </p>
        }
        @if(!showCompleteProfileCard) {
          <mnt-button
            class="w-100 mt-3"
            variant="emphasis"
            color="primary"
            size="large"
            full-width
            [disabled]="!phoneDataIsValid || submitting"
            [label]="submitting ? 'Verificando...' : origin == 'MENU' ? 'Fazer pedido' : 'Continuar'"
            [iconLeft]="submitting ? 'loading' : ''"
            animation="submitting ? 'spin' : ''"
            (buttonClick)="handleContinue()"
          ></mnt-button>
        }
      </div>

      @if(showCompleteProfileCard) {
        <div class="mt-3 d-column gap-3">
          <div
            class="complete-profile-card d-column gap-2 p-3"
            style="background-color: #f1f9fe; border: 1px solid #bde3fa; border-radius: 12px;"
          >
            <div class="d-column gap-1 w-100">
              <div class="d-flex align-items-center justify-between  w-100">
                <h2 style="margin: 0; font-size: 16px; line-height: 24px; font-weight: 600; color: #242628; padding-right: 8px;">
                  Complete seu cadastro
                </h2>
                <div class="d-flex align-items-center justify-content-center">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M12 20.25C12 20.25 2.625 15 2.625 8.62501C2.62519 7.49826 3.01561 6.40635 3.72989 5.53493C4.44416 4.66351 5.4382 4.06636 6.54299 3.84501C7.64778 3.62367 8.79514 3.79179 9.78999 4.32079C10.7848 4.84979 11.5658 5.70702 12 6.74673L12 6.74673C12.4342 5.70702 13.2152 4.84979 14.21 4.32079C15.2049 3.79179 16.3522 3.62367 17.457 3.84501C18.5618 4.06636 19.5558 4.66351 20.2701 5.53493C20.9844 6.40635 21.3748 7.49826 21.375 8.62501C21.375 15 12 20.25 12 20.25Z" stroke="#0B7CBE" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </div>
              </div>

              <p style="margin: 0; font-size: 14px; line-height: 20px; font-weight: 400; color: #3a3d3f;">
                Informe seus dados para receber nossas
                <span class="text-color-primary">promoções</span> e
                <span class="text-color-primary">descontos.</span>
              </p>
            </div>

            <div class="d-column gap-2 w-100">
              <mnt-field-text
                class="w-100"
                label-text="E-mail"
                id="field-email-input"
                required
                placeholder="Ex: lucascosta@gmail.com"
                type="email"
                size="large"
                color="primary"
                [value]="email"
                (input)="handleEmailChange($event)"
                [state]="emailState"
                [inlineMessage]="emailMessage"
              ></mnt-field-text>

              <mnt-field-text
                #birthdayField
                class="w-100"
                label-text="Data de aniversário"
                id="field-birthday-input"
                required
                placeholder="Ex: 08/07/1995"
                inputmode="numeric"
                autocomplete="bday"
                maxlength="10"
                size="large"
                color="primary"
                [value]="birthday"
                (input)="handleBirthdayInput($event)"
                [state]="birthdayState"
                [inlineMessage]="birthdayMessage"
              ></mnt-field-text>
            </div>
          </div>

          <mnt-button
            class="w-100"
            label="Concluir"
            variant="emphasis"
            color="primary"
            size="large"
            full-width
            [disabled]="false"
            (buttonClick)="handleCompleteProfile()"
          ></mnt-button>
        </div>
      }
    </div>
  } @else if(step === 'name') {
    <div class="dialog-body">
      <h2 class="title-large mb-3">
        Como quer ser chamado?
      </h2>

      <mnt-field-text
        class="w-100"
        label-text="Nome"
        id="field-name-input"
        required
        placeholder="Ex: João da Silva"
        size="large"
        color="primary"
        (change)="handleNameChange($event)"
      ></mnt-field-text>

      <mnt-button
        class="w-100 mt-3"
        label="Concluir e fazer pedido"
        variant="emphasis"
        color="primary"
        size="large"
        full-width
        (buttonClick)="handleRegister()"
      ></mnt-button>
    </div>
  }
</div>
